export default "__VITE_ASSET__CLkh5h2P__"